<template>
  <v-form ref="form">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.user.user') }}</span>
      </v-card-title>
      	<element-tree
		    	:data="items"
		    	:expanded="expanded"
		    	@return-all="returnAll"
		    	ref="userTree"
		    	></element-tree>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" dark  @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}</v-btn>
        <v-btn color="success" dark  @click="saveUserOrgRelation">{{ $vuetify.lang.t('$vuetify.custom.addBtn') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<style></style>
<script>
	import ElementTree from '@/components/tree/ElementTree'
  export default {

    name: 'userBind',
    model:{
      prop:'dialog',
      event:'parent-event'
    },
    props:{
      dialog:Boolean,
        orgId : {
                type : String
        },
    },
    data: () => ({

        expanded:[],//默认展开
				roleArray:[],//角色列表
				userChecked:[],//选中用户
				selectedRoleId:'',//当前选中角色
		    items: [],//用户树
                userDeal:false,//用户关系修改标识
      formData: {
        username: '',
        password: '',
        realname: ''
      },
      rules: {
        required: value => !!value || '请输入'
      },
    }),
    created(){
        this.getTree();
        this.listRole();
    },
    methods:{
            hiddenDialog(){
                  this.getTree();
                  this.listRole();
                  this.$emit('initialize');
                  this.$refs.form.reset()
                  this.$refs.userTree.reset()

              },
        	//查询与当前选中角色绑定的用户
			queryUserRoleRelation(roleId){
              this.$api.sysOrganization.listUserOrgRelation(this.orgId).then(data => {
              if(data.flag){
                let array = [];
                            array = [...data.data];
                this.$refs.userTree.setCheckedKeys(array);
              }
            })
        },
      //保存组织与用户的关系
			saveUserOrgRelation(){
          if(!this.userDeal){
                      this.$dialog.alert("请操作后再保存");
                  }else{
                        let obj = {
                            orgId:this.orgId,
                            userIds:this.userChecked
                        }
                        this.$api.sysUserOrganization.saveUserOrgRelation(obj).then(data =>{
                            if(data.flag){
                                this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.preservation') + this.$vuetify.lang.t('$vuetify.custom.success'));
                                this.$emit('initialize');
                                this.hiddenDialog();
                            }else{
                                this.$dialog.alert(data.msg)
                            }
                        })
                  }
			},
			//查询角色
			async listRole(){
				await this.$api.sysUserRole.listRole().then(data =>{
                      if(data.flag){
                        this.roleArray = data.data;
                      }
                    })
			        	this.queryUserRoleRelation(this.roleArray[0].id);
            },
            //获取选中用户
          returnAll(val){
              this.userChecked = [];
              this.userDeal = true;
            for(let v of val){
              if(val.length==1&&v=="001"){
                this.userDeal=false;
                continue;
              }
               if(v=="001"){
                continue;
              }
                this.userChecked.push(v);
            }
          },
          //查询用户树
          async getTree(){
            await this.$api.sysUserOrganization.treeUser().then(data =>{
                        if(data.flag){
                          this.items = data.data;
                          let array = [];
                          array.push(data.data[0].id);
                          this.expanded = array;
                        }
               })
          },
            addUser() {
                if (this.$refs.form.validate()) {
                this.$api.sysUser.addUserBase(this.formData).then(data => {
                    if (data.flag) {
                    this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.addSuccess'));
                    this.$emit('initialize');
                    this.hiddenDialog();
                    }else{
                    this.$dialog.alert(data.msg)
                    this.$refs.form.reset()
                    this.$refs.userTree.reset()
                    }
                })

            }
        }
        },
    	components:{
			ElementTree
		}
  }
</script>
